// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/audit.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { DateRange, Pagination, PaginationMeta, ResourceKind } from "./common_pb.js";

/**
 * AuditEvent is an append-only row in ClickHouse `tracker.audit_log`. It is
 * the canonical source for the Logs page.
 *
 * @generated from message tracker.v1.AuditEvent
 */
export class AuditEvent extends Message<AuditEvent> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string ts = 2;
   */
  ts = "";

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId = "";

  /**
   * @generated from field: string actor_id = 4;
   */
  actorId = "";

  /**
   * @generated from field: string actor_email = 5;
   */
  actorEmail = "";

  /**
   * e.g. "campaign.update", "offer.archive"
   *
   * @generated from field: string action = 6;
   */
  action = "";

  /**
   * @generated from field: tracker.v1.ResourceKind resource_kind = 7;
   */
  resourceKind = ResourceKind.UNSPECIFIED;

  /**
   * @generated from field: string resource_id = 8;
   */
  resourceId = "";

  /**
   * @generated from field: string before_json = 9;
   */
  beforeJson = "";

  /**
   * @generated from field: string after_json = 10;
   */
  afterJson = "";

  /**
   * @generated from field: string request_id = 11;
   */
  requestId = "";

  /**
   * @generated from field: string ip = 12;
   */
  ip = "";

  /**
   * @generated from field: string user_agent = 13;
   */
  userAgent = "";

  constructor(data?: PartialMessage<AuditEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AuditEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ts", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "actor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "actor_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "resource_kind", kind: "enum", T: proto3.getEnumType(ResourceKind) },
    { no: 8, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "before_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "after_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuditEvent {
    return new AuditEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuditEvent {
    return new AuditEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuditEvent {
    return new AuditEvent().fromJsonString(jsonString, options);
  }

  static equals(a: AuditEvent | PlainMessage<AuditEvent> | undefined, b: AuditEvent | PlainMessage<AuditEvent> | undefined): boolean {
    return proto3.util.equals(AuditEvent, a, b);
  }
}

/**
 * @generated from message tracker.v1.SearchAuditEventsRequest
 */
export class SearchAuditEventsRequest extends Message<SearchAuditEventsRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: tracker.v1.DateRange range = 2;
   */
  range?: DateRange;

  /**
   * @generated from field: string actor_id = 3;
   */
  actorId = "";

  /**
   * @generated from field: tracker.v1.ResourceKind resource_kind = 4;
   */
  resourceKind = ResourceKind.UNSPECIFIED;

  /**
   * @generated from field: string resource_id = 5;
   */
  resourceId = "";

  /**
   * @generated from field: string action = 6;
   */
  action = "";

  /**
   * @generated from field: string search = 7;
   */
  search = "";

  constructor(data?: PartialMessage<SearchAuditEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SearchAuditEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "range", kind: "message", T: DateRange },
    { no: 3, name: "actor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "resource_kind", kind: "enum", T: proto3.getEnumType(ResourceKind) },
    { no: 5, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchAuditEventsRequest {
    return new SearchAuditEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchAuditEventsRequest {
    return new SearchAuditEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchAuditEventsRequest {
    return new SearchAuditEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchAuditEventsRequest | PlainMessage<SearchAuditEventsRequest> | undefined, b: SearchAuditEventsRequest | PlainMessage<SearchAuditEventsRequest> | undefined): boolean {
    return proto3.util.equals(SearchAuditEventsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SearchAuditEventsResponse
 */
export class SearchAuditEventsResponse extends Message<SearchAuditEventsResponse> {
  /**
   * @generated from field: repeated tracker.v1.AuditEvent items = 1;
   */
  items: AuditEvent[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<SearchAuditEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SearchAuditEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: AuditEvent, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchAuditEventsResponse {
    return new SearchAuditEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchAuditEventsResponse {
    return new SearchAuditEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchAuditEventsResponse {
    return new SearchAuditEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchAuditEventsResponse | PlainMessage<SearchAuditEventsResponse> | undefined, b: SearchAuditEventsResponse | PlainMessage<SearchAuditEventsResponse> | undefined): boolean {
    return proto3.util.equals(SearchAuditEventsResponse, a, b);
  }
}

